import Side from "../others/SideMenu";
import User from '../others/User';
import { DatePicker, Select, Button, Steps, QRCode, Space, Table, Tag, Form, Popover, Spin, message, InputNumber, Input, Rate  } from "antd"
import { SendOutlined, DownloadOutlined, EyeOutlined  } from "@ant-design/icons"
import dayjs from 'dayjs';
import { getAimag, getRequest, getRequests, sendToMail, downToMail, getSettings, getDefinition, getDefinitions, getRate, downloadFile  } from '../../redux/actions/obsAction';
import { createInvoice, checkPayment, getInvoice, Check_callback_url } from '../../redux/actions/payAction';
import { getLogin, LogOut, updateUser } from '../../redux/actions/userAction';

import { useState, useEffect } from 'react';
import { connect } from "react-redux";
import QpayLogo from "../../icon/qpaypayment.svg"
import { Link } from "react-router-dom";
import FileDownload from "js-file-download";
import CurrencyFormatter from "./CurrencyFormatter";

const { RangePicker } = DatePicker;
const { TextArea } = Input;

const reducer = ({ user, obs, pay }) => ({  user, obs, pay });
const Pages=(props)=>{
    const { user, obs, pay } = props

    const { Option } = Select;
    const [dateFormat, setDateFormat] = useState('YYYY-MM-DD')
    const [dateType, setDateType] = useState('date')
    const [aimags, setAimags] = useState([])
    const [createInvo,setCreateInvo] = useState({})

    const [selValue, setSelValue] = useState(0);
    const [reqId, setReqId] = useState(0);
    const [invId, setInvId] = useState(0);
    const [checkPay, setCheckPay] = useState("");
    const onChange = (value) => {
      setSelValue(value)
    };
    
    const onSearch = (value) => {
      setSelValue(value)
    };

    const createPayment=()=>{
        props.dispatch(createInvoice({id:reqId,amount:amount, tableName:'requestDefinition'})).then(c=>{
            setCreateInvo(c)
           if(c.createInvoice?.invoice_id){
                setInvId(c.createInvoice?.invoice_id)
                next()
           }
        })
    }
    const checkPaymentClick=()=>{
        if(invId){
            props.dispatch(checkPayment({id:invId, tableName:'requestDefinition'})).then(c=>{
            setCheckPay(c)
            if(c.checkPayment?.count>0){
                next()
            }
           })
        }else{
            return message.warning('Нэхэмжлэл үүсээгүй байна', 5);
        }

    }

    
    const options_type= [
        {
            value:"paper",
            label: "Өөрийн биеэр ирж авах",
        }, 
        {
            value:"electronic",
            label: "Цахим шуудан хаягаар авах",
        }
    ];

    const [form] = Form.useForm();
    const [amount, setAmount] =useState(0)
    const onFinish = (values) => {
        const today = dayjs()
        const weekdayName = today.format('dddd') // ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
     
        if(weekdayName=='Saturday' || weekdayName=='Sunday'){
           return message.warning("Та энэхүү үйлчилгээг ажлын өдрөөр авна уу. Баярлалаа",5)
        } else {
            if( today.format("HH")>='17:30' || today.format("HH")<'08:30'){
                return message.warning("Та энэхүү үйлчилгээг ажлын цагаар авна уу. Ажлын цаг 08:30-17:30. Баярлалаа",5)
            }
        }
       
        if(values.start_date>values.end_date){
            return message.warning('Хугацаа буруу байна. Эхлэх хугацаа дуусах хугацаагаас бага байх ёстой', 5);
        }
        props.dispatch(getDefinition(values)).then(c=>{
            if(!c.success){
                return message.warning('Дахин оролдоно уу', 5);
            }else{
                setAmount(c.definition?.pay_amount)
                setReqId(c.definition?.id)
                next()
            }
        })
    };

    const [callbackStatus, setCallbackStatus] = useState(0)
    useEffect(()=>{
        props.dispatch(getLogin()).then(res=>{
            form.setFieldsValue({
                email: res.auth.email,
                firstname: res.auth.firstname,
                lastname: res.auth.lastname,
                phone: res.auth.phone,
            });
        })
        props.dispatch(getDefinitions())
        props.dispatch(getSettings())
    },[])

    const [isActive, setIsActive] = useState(true);

    useEffect(()=>{
        let id;
        if(isActive && reqId>0){
            id =  setInterval(() => {
                props.dispatch(Check_callback_url({id:reqId,tableName:'requestDefinition'})).then(c=>{
                    if(c?.payment_id>0){
                        setIsActive(false)
                    }
                    setCallbackStatus(c?.payment_id)
                })
            }, 4000);
        }
        return () => clearInterval(id);
    },[isActive, reqId])

    const onSendFile=(val)=>{
        if(checkPay?.checkPayment?.count>0){
            let request = checkPay.request
            props.dispatch(sendToMail({
                fileType:request.fileType,
                id:request.id
            })).then(c=>{
                if (c?.sendStatus){
                    message.success("Амжилттай илгээлээ.",5)
                }else{
                    message.warning("Системийн алдаа гарлаа.",5)
                }
            })
        }
        if(val?.id>0){
            let request = val
            props.dispatch(sendToMail({
                fileType:request.fileType,
                id:request.id
            })).then(c=>{
                if (c?.sendStatus){
                    message.success("Амжилттай илгээлээ.",5)
                }else{
                    message.warning("Системийн алдаа гарлаа.",5)
                }
            })
        }
    }
    const onDownloadFile=(el)=>{
        if(el){
            const filename = el.split("/")
            if(filename.length>4){
                props.dispatch(downloadFile({filename:filename[5]})).then(res=>{
                    FileDownload(res,`${filename[5]}`)
                })
            }
        }
    }
    const [rateVisible, setRateVisible]= useState(true)
    const onChangeRate=(e)=>{
        props.dispatch(getRate({rating:e}))
        setRateVisible(false)
        message.success("Таны санал бидэнд маш үнэ цэнэтэй. Санал өгсөнд баярлалаа!")
    }

    const steps = [
        {
          title: 'Мэдээлэл оруулах',
          content: <div className="flex md:min-h-96 flex-col items-center justify-center w-full">                
                   
                    <Form.Item
                        name="organization"
                        label="Хаана зориулж авах"
                        className='2xl:w-8/12 w-full m-0 p-0 mb-6'
                        rules={[
                            {
                            required: true,
                            message: '* Овог нэрээ оруулна уу',
                            }
                        ]}
                        >
                            <TextArea
                                placeholder="Жишээ нь: Онцгой байдлыг ерөнхий газарт, Монгол даатгалд ..."
                                autoSize={{ minRows: 2, maxRows: 6 }}
                                allowClear
                            />
                            {/* <Input placeholder="Хаана зориулж авах Жишээ нь: Онцгой байдлыг ерөнхий газарт, Даатгалд"/> */}
                    </Form.Item>

                    <Form.Item
                        name="lastname"
                        label="Овог нэр"
                        className='2xl:w-8/12 w-full m-0 p-0 mb-6'
                        rules={[
                            {
                            required: true,
                            message: '* Овог нэрээ оруулна уу',
                            }
                        ]}
                        >
                            <Input allowClear placeholder="Овог нэр"/>
                    </Form.Item>

                    <Form.Item
                        name="firstname"
                        label="Өөрийн нэр"
                        className='2xl:w-8/12 w-full m-0 p-0 mb-6'
                        rules={[
                            {
                            required: true,
                            message: '* Өөрийн нэрээ оруулна уу',
                            }
                        ]}
                        >
                            <Input allowClear placeholder="Өөрийн нэр"/>
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label="И-мэйл"
                        className='2xl:w-8/12 w-full m-0 p-0 mb-6'
                        rules={[
                            {
                            required: true,
                            message: '* И-мэйл оруулна уу',
                            }
                        ]}
                        >
                            <Input allowClear type="email" placeholder="И-мэйл хаяг"/>
                    </Form.Item>
                    <Form.Item
                        name="phone"
                        label="Утас"
                        className='2xl:w-8/12 w-full m-0 p-0 mb-6'
                        rules={[
                            {
                            required: true,
                            message: '* Утасны дугаар оруулна уу',
                            }
                        ]}
                        >
                            <Input allowClear type="number" placeholder="Утасны дугаар"/>
                    </Form.Item>
                    <Form.Item
                        name="location"
                        label="Цаг агаарын үзэгдэл болсон газар нутаг"
                        className='2xl:w-8/12 w-full m-0 p-0 mb-6'
                        rules={[
                            {
                            required: true,
                            message: 'Аймаг, Сумын нэр оруулна уу',
                            }
                        ]}
                        >
                            <TextArea
                                placeholder="Жишээ нь: Архангай аймгийн Тариат сум ..."
                                autoSize={{ minRows: 2, maxRows: 6 }}
                                allowClear
                            />
                        {/* <Select
                            mode="multiple"
                            allowClear
                            className='w-full text-sm outline-none rounded-md focus:ring-2 cursor-pointer'
                            placeholder="Жишээ нь: Архангай, Тариат"
                            optionFilterProp="children"
                            value={selValue}
                            onChange={onChange}
                            onSearch={onSearch}
                            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                            // options={aimags}
                        >
                            {
                                (aimags || [].length>0) ?
                                    (aimags || []).map((el,i)=>
                                        <Option key={i} value={el.station_id}>{`${el.aimag}, ${el.sum}`}</Option>
                                        // {
                                        //     label:`${el.aimag}, ${el.sum} [${el.station_id}]`,
                                        //     value:el.station_id
                                        // }, 
                                    ) 
                                : null
                            }
                        </Select> */}
                    </Form.Item>
                    <Form.Item
                        name="element"
                        label="Болсон цаг агаарын үзэгдэл(Элемент)"
                        className='2xl:w-8/12 w-full m-0 p-0 mb-6'
                        rules={[
                            {
                            required: true,
                            message: '* Элемент оруулна уу',
                            }
                        ]}
                        >
                        {/* <Input placeholder="Жишээ нь: Цасан шуурга, Шороон шуурга"/> */}
                        <TextArea
                            placeholder="Жишээ нь: Цасан шуурга, Шороон шуурга ..."
                            autoSize={{ minRows: 2, maxRows: 6 }}
                            allowClear
                        />
                    </Form.Item>
                    <Form.Item
                        name="odate"
                        label="Хамаарах хугацаа сонгох"
                        className='2xl:w-8/12 w-full m-0 p-0 mb-6'
                        rules={[
                            {
                            required: true,
                            message: 'Хамаарах хугацаа сонгоно уу',
                            },
                            {
                                validator: (_, value) => {
                                  if (!value || value.length !== 2) {
                                    return Promise.reject('2 огноо сонгоно уу');
                                  }
                                  const diff = value[1].diff(value[0], 'day');
                                  if (diff > 31) {
                                    return Promise.reject('30 хоногоос их хугацаа сонгох боломжгүй! Хэрвээ та 31 хоногоос их хугацааны мэдээлэл авах бол "Цаг уурын горимын ажиглалтын мэдээ авах” цэсийг ашиглана уу.');
                                  }
                                  return Promise.resolve();
                                },
                              },
                        ]}
                        >
                        <RangePicker className='w-full outline-none rounded-md focus:ring-2' initialValues={dayjs(new Date(),dateFormat)} format={dateFormat} />
                        {/* <DatePicker className='w-full outline-none rounded-md focus:ring-2' picker={dateType} initialValues={dayjs(new Date(),dateFormat)} format={dateFormat} /> */}
                    </Form.Item>
                    <Form.Item
                        name="explain"
                        label="Нэмэлт тайлбар бичих"
                        className='2xl:w-8/12 w-full m-0 p-0 mb-6'
                        rules={[
                            {
                            message: 'Нэмэлт тайлбар бичих',
                            }
                        ]}
                        >
                            <TextArea
                                placeholder="Жишээ нь: 2023 оны 03-р сарын 22-ны өдөр 12 цагт Увс аймгийн Тэс сум орчим хүчтэй салхи, шороон шуурга болсон."
                                autoSize={{ minRows: 2, maxRows: 6 }}
                                allowClear
                            />
                       
                    </Form.Item>
                  
                    <Form.Item
                        name="outputType"
                        label="Гаралтын хэлбэр"
                        className='2xl:w-8/12 w-full m-0 p-0 mb-6'
                        rules={[
                            {
                            required: true,
                            message: 'Гаралтын хэлбэр сонгоно уу',
                            }
                        ]}
                        >
                        <Select
                            allowClear
                            className='w-full md:w-96 text-sm outline-none rounded-md focus:ring-2 cursor-pointer'
                            placeholder="Гаралтын хэлбэр сонгох"
                            // defaultValue={['a10', 'c12']}
                            // onChange={handleChange}
                            options={options_type}
                        />
                    </Form.Item>
          </div>,
        },
        {
            title: 'Төлбөр төлөх суваг сонгох',
            content: <>
                   <div className='w-full bg-white rounded-md h-auto sm:h-96 p-2 flex items-center justify-center text-slate-500'>
                    <div>
                        <div className="flex justify-center text-lg mb-2 text-red-600 w-full">
                                <p className="mr-1">Төлөх мөнгөн дүн: </p>
                                <p className="font-bold">
                                    {/* {amount}₮ */}
                                    <CurrencyFormatter amount={amount} locale="mn-MN" currency="MNT" />₮ 
                                </p>
                        </div>
                        <Button onClick={createPayment} className='text-center flex flex-col sm:flex-row h-auto justify-start items-center border boder-slate-500 p-4 rounded-xl hover:bg-slate-100 cursor-pointer focus:border-blue-500'>
                            <img src={QpayLogo} className="w-16 sm:mr-2" alt="qpay_logo"/>
                            <div className="text-center sm:text-left">
                                <h5 className="font-bold">QPay-ээр төлөх</h5>
                                <p className="text-sm hidden sm:flex">Qpay ашиглан QR код уншуулан төлбөр төлөх</p>
                            </div>
                        </Button>
                    </div>
                  </div>
            </>,
          },
        {
          title: 'Төлбөр төлөх',
          content: <>
                <Spin spinning={createInvo=={} ? true : false}>
                    <div className='w-full bg-white rounded-md md:h-96 p-2 flex flex-col items-center justify-center text-slate-500 text-sm'>
                        <div className='flex flex-col items-center justify-start 2xl:w-7/12 w-full mt-2'>
                            <p className='my-4'><span className='text-blue-500'>* </span>Анхаар: Төлбөр төлсөний дараа Баталгаажуулах товч гарч ирнэ.</p> 
                                {
                                    createInvo!={} ?
                                    // <QR text ={pay.createInvoice.qr_text}/>
                                    <QRCode 
                                        size={200} 
                                        // iconSize={200 / 8} 
                                        value={createInvo?.createInvoice?.qr_text} 
                                        // icon={QpayLogo}
                                    />
                                    : null
                                }
                            <div className='text-center'>
                                {
                                    checkPay!=="" ?
                                        <p className={`my-4 ${ checkPay.checkPayment?.count>0? 'text-green-600' : 'text-red-600'} `}><span className={`${ checkPay.checkPayment?.count>0? 'text-green-600' : 'text-red-600'} `}>* </span>{
                                            checkPay.checkPayment?.count>0? 'Төлбөр амжилттай төлөгдлөө' : 'Төлбөр төлөгдөөгүй байна.'
                                        }</p>
                                    :null
                                }
                                {
                                    callbackStatus>0 ?
                                    <>
                                    <p className='hidden md:flex my-4'><span className='text-red-500'>* </span>Төлбөр баталгаажсан эсэхийг заавал шалгана уу.</p> 
                                    <Button loading={pay.checkPayLoading} onClick={checkPaymentClick} type='primary' className='mb-4 border-none bg-blue-500 text-white rounded-md hover:bg-blue-400 duration-200'>Төлбөр баталгаажуулах</Button>
                                    </>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </Spin>
          </>,
        },
        {
          title: 'Дууслаа',
          content: <>
             <div className='w-full bg-white rounded-md md:h-96 p-2 flex flex-col items-center justify-center text-slate-500 text-sm'>
                <div className='flex flex-col items-center justify-end 2xl:w-7/12 w-full mt-2'>
                    <p className='text-blue-600 font-semibold text-lg mb-4 text-center'>
                        Таны хүсэлтийг хүлээн авлаа. Бид таны хүссэн тодорхойлтыг таны цахим шуудан хаяг руу илгээх болно. Мөн та өөрийн биеэр ирж авах боломжтой. Баярлалаа. Утас:51-264152 </p>
                    {rateVisible && <Rate onChange={onChangeRate} />}
                </div>
            </div>
          </>,
        },
      ];
    const [current, setCurrent] = useState(0);
    const [continBtn, setContinBtn] = useState(true);
    const next = () => {
        setCurrent(current + 1)
        if(current +1>0){
            setContinBtn(false)
        }
    };
    const prev = () => {
        setCurrent(current - 1);
        if(current - 1===0){
            setContinBtn(true)
        }
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));

   const columns = [
        {
            title: '№',
            key: 'number',
            render:(item, record, index)=>(<>{index+1}</>)
          },
          {
            title: 'Овог нэр',
            dataIndex: 'lastname',
            key: 'lastname',
          },
          {
            title: 'Өөрийн нэр',
            dataIndex: 'firstname',
            key: 'firstname',
          },
          {
            title: 'Цахим шуудан',
            dataIndex: 'email',
            key: 'email',
          },
          {
            title: 'Утас',
            dataIndex: 'phone',
            key: 'phone',
          },
          {
            title: 'Хаан зориулж',
            dataIndex: 'organization',
            key: 'organization',
          },
        {
          title: 'Элемент',
          dataIndex: 'element',
          key: 'element',
        },
    
          {
            title: 'Байршил',
            dataIndex: 'location',
            key: 'location',
          },
     
        {
          title: 'Хамаарах хугацаа',
          dataIndex: 'odate',
          key: 'odate',
          render: (odate) => <div key={odate}>
            {
                (odate.split(",") || []).map((el,i)=><p key={i}>{dayjs(el).format("YYYY-MM-DD")}</p>)
            }
          </div>,
        },
        {
          title: 'Төлбөрийн төлөв',
          key: 'pay_status',
          dataIndex: 'pay_status',
          responsive: ['lg'],
          filters: [
            {
              text: 'Төлөгдөөгүй',
              value: 'pending',
            },
            {
              text: 'Төлсөн',
              value: 'paid',
            }],
            filterSearch: true,
            onFilter: (value, record) => record.pay_status.includes(value),
            render: (_, { pay_status }) => (
                <>
                {
                    (
                        <Tag color={pay_status==="pending"? "red":'green'} key={pay_status}>
                        {pay_status==="pending"? "Төлөгдөөгүй":'Төлсөн'}
                        </Tag>
                    )
                }
                </>
            ),
        },
        {
            title: 'Төлбөрийн дүн',
            dataIndex: 'pay_amount',
            key: 'pay_amount',
            render: (value) => <>{
              value
            }₮</>,
            // responsive: ['lg'],
          },
  
        {
            title: 'Үүсгэсэн хугацаа',
            dataIndex: 'created',
            key: 'created',
            // responsive: ['xl'],
            render: (date) => <>{dayjs(date).add(-8,'hours').format("YYYY-MM-DD HH:mm")}</>,
        },
        {
          title: 'Үйлдэл',
          key: 'action',
        //   responsive: ['sm'],
          render: (record) => (
            <Space direction="horizontal"  size="small">
                {
                    record?.fileStatus==='active' ?
                    <>
                    {
                        record.filePath.split(",").map((el,i)=>
                            <Popover
                                key={`popov-${i}`}
                                content={"Татах"}>
                                <div key={i} onClick={()=>onDownloadFile(el)} className="bg-blue-500 py-2 px-4 rounded-xl text-white hover:bg-blue-600 flex items-center cursor-pointer"><DownloadOutlined /></div>
                            </Popover>
                          )
                    }
                        {/* <Popover  title="Татаж авах">
                            <Button onClick={()=>onDownloadFile(record)} shape="circle" type="primary" className='border-none bg-blue-500 text-white rounded-md w-full hover:bg-blue-300 hover:text-white duration-300 flex justify-center items-center' icon={<DownloadOutlined />} ></Button>
                        </Popover>
                        <Popover  title="Цахим хаяг руу илгээх">
                            <Button loading={obs?.sending} onClick={()=>{onSendFile(record)}} shape="circle" className='border-none bg-green-500 text-white rounded-md w-full hover:bg-green-400 hover:text-white duration-300 flex justify-center items-center' icon={<SendOutlined />}></Button>
                        </Popover> */}
                    </>
                : record?.pay_status==='paid' ?                 
                <p>Боловсруулж байна. Та түр хүлээнэ үү.</p> : null
                }

            </Space>
          ),
        },
      ];


    return(
        <div className='grid grid-rows-6 grid-cols-6 gap-4'>
            <div className="xl:row-span-6 col-span-1"><Side selected={props.selected}/></div>
            <div className="xl:row-span-1 col-span-5 flex justify-end"><User user={user}/></div>
            <div className="row-span-6 xl:row-span-5 col-span-6 xl:col-span-5 flex justify-start p-4">
            {
                props.selected=='definition' &&
                <Form
                    form = {form}
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    name="complex-form"
                    className='w-full text-slate-500 text-sm h-96'
                    onFinish={onFinish}
                >
                    <div className="w-auto">
                        <p className="text-red-500 bg-white rounded-md mb-2 font-semibold text-justify py-1 px-4 shadow-md">Анхааруулга: Хэрэв танд 30 хоногоос давсан хугацаатай цаг уурын мэдээлэл шаардлагатай бол “Цаг уурын горимын ажиглалтын мэдээ авах” цэсийг ашиглана уу. Мөн 51-264152 дугаарын утсаар холбогдож нэмэлт мэдээлэл авах боломжтой."</p>
                    </div>
                    <div className='flex flex-col justify-betwseen w-full bg-white p-4 rounded-md'>
                        <Steps current={current} items={items} />
                            <div className="mt-4">{steps[current].content}</div>
                            <Form.Item >
                                <div className="flex justify-between items-center sm:justify-start">
                                    {
                                        continBtn ?
                                    current < steps.length - 1 && (
                                        //loading={obs.loading} 
                                        <Button loading={obs?.loading || false} htmlType="submit" className='bg-blue-500 border-1 border-blue-500 text-white hover:bg-white hover:text-blue-500'
                                        >
                                            Үргэлжлүүлэх
                                        </Button>
                                    )
                                : null}
                                    {current > 0 && (
                                        <Button
                                        className='bg-white border-1 border-blue-500  mx-2 text-blue-500 hover:bg-blue-500 hover:text-white'
                                        onClick={() => prev()}
                                        >
                                        Өмнөх
                                        </Button>
                                    )}
                                </div>
                        </Form.Item>
                    </div>
                    <div className="mt-4">
                    Төлбөр тооцоолох тухай Архивын ерөнхий газрын даргын 2021 оны 3 дугаар сарын 12-ны өдрийн А/24 тоот тушаалын 3 дугаар хавсралт, 
                    <Link target="_blank" className="text-blue-500 font-bold mt-4" to="https://legalinfo.mn/mn/detail?lawId=16760268695071&showType=1"> тушаалын хуулбар</Link>
                    </div>
                </Form>
            }
            {
                props.selected=='definitionList' &&
                    <Table 
                        key={"definitionList-table"}
                        className="w-full h-36" 
                        columns={columns} 
                        dataSource={obs?.definitions || []} 
                        pagination={{
                            pageSize: 10,
                        }}
                        // expandable={{
                        //     expandedRowRender: (record) => (
                        //     <Space
                        //     direction="vertical"
                        //     size="small"
                        //     className="w-auto"
                            
                        //     >
                        //     <div>Элемент:{
                        //             (record.element) 
                        //     }</div>
                        //     <div>Хугацааны төрөл:{record.dateType}</div>
                        //     <div>Индекс:{record.sums}</div>
                        //     <div>Мэдээний Хугацаа:{record.start_date}-{record.end_date}</div>
                        //     <div>Төлбөр:
                        //         <Tag color={record.pay_status==="pending"? "red":'green'} key={record.pay_status}>
                        //         {record.pay_status==="pending"? "Төлөгдөөгүй":'Төлсөн'}
                        //         </Tag>
                        //     </div>
                        //     <div>Төлбөр:{record.pay_amount}₮</div>
                        //     <Space direction="horizontal"  size="small">
                        //     {
                        //         record?.pay_status==='paid' ?
                        //         <>
                        //         <Popover  title="Татаж авах">
                        //                 <Button onClick={()=>onDownloadFile(record)} shape="circle" type="primary" className='border-none bg-blue-500 text-white rounded-md w-full hover:bg-blue-300 hover:text-white duration-300 flex justify-center items-center' icon={<DownloadOutlined />} ></Button>
                        //             </Popover>
                        //             <Popover  title="Цахим хаяг руу илгээх">
                        //                 <Button loading={obs?.sending} onClick={()=>{onSendFile(record)}} shape="circle" className='border-none bg-green-500 text-white rounded-md w-full hover:bg-green-400 hover:text-white duration-300 flex justify-center items-center' icon={<SendOutlined />}></Button>
                        //             </Popover>
                        //         </>
                        //     : null
                        //         // <Button onClick={()=>backCallInovice(record)} className='border-none bg-green-500 text-white rounded-md w-full hover:bg-green-400 duration-300 flex justify-center items-center'>Төлбөр төлөх</Button>
                        //     }

                        // </Space>
                        //     </Space>
                            
                        //     ),
                        //     // rowExpandable: (record) => 
                        //     // (
                        //     //   (record.sums).split(',').length !==1                          
                        //     // )
                        // }}
                    />
            }

            </div>
        </div>
    )
}

export default connect(reducer)(Pages);